<template>
    <b-form-row>
        <b-col cols="12" :class="{ 'dd': !!is_selection_value_type }">
            <label class="mb-3"><strong>{{ value_name || $translate('value') }}</strong></label>
            <b-form-select  @change="complete_task()" v-if="!!is_selection_value_type" id="TaskValue" class="form-control"
                v-model="itemModel.task_value" :options="value_selections" :disabled="disabled">
                <template #first>
                    <b-form-select-option :value="null" disabled>
                        {{ $translate('select_value') }}
                    </b-form-select-option>
                </template>
            </b-form-select>
            <b-form-input v-else  @change="complete_task()" id="TaskValue" name="TaskValue" :placeholder="$translate('enter_value')"
                type="number" :min="value_min || 0" :max="value_max || 1000" step="any" v-model="itemModel.task_value"
                :readonly="disabled" />
        </b-col>

        <b-col cols="12" class="mt-3">
            <label class="mb-3" for="TaskNotes"><strong>{{ $translate('notes') }}</strong></label>
            <!-- <b-form-textarea class="" id="TaskNotes" name="TaskNotes" :placeholder="$translate('enter_notes')"
                v-model="itemModel.task_notes" :readonly="disabled" /> -->
                <textarea-with-audio 
                    v-model="itemModel.task_notes" 
                    :idAttr="'TaskNotes'"
                    :placeholderAttr="$translate('enter_notes')" 
                    :rows="6" 
                    :maxRows="10"
                    :disabledAttr="disabled"
                />
        </b-col>
        <b-col cols="6" class="mt-2 mb-3 pt-2 ps-1 d-flex align-items-center">
            <div class="form-check me-2">
                <label class="form-check-label">
                    <input type="checkbox" id="task-check" class="form-check-input" v-model="itemModel.task_checked"
                        name="taskChecked" :value="1" :unchecked-value="0" :disabled="disabled" />
                    <i class="input-helper"></i>
                </label>
            </div>
            <label for="task-check" class="mb-0"><strong>{{ $translate('completed') }}</strong></label>
        </b-col>
    </b-form-row>
</template>
<script>
import TextareaWithAudio from '@/components/TextareaWithAudio.vue'

export default {
    name: 'orders-ViewTask',

    components: {'textarea-with-audio': TextareaWithAudio},
    props: ['value', 'masterItem', 'disabled'],

    computed: {
        value_name() {
            console.log('masterItem', this.masterItem)
            return this.masterItem && this.masterItem.value_name
        },
        value_selections() {
            try {
                const _selections = JSON.parse(
                    this.masterItem && this.masterItem.value_selections
                )
                if (!Array.isArray(_selections)) throw new Error('Not Array')
                return _selections
            } catch (err) {
                return []
            }
        },
        value_max() {
            return (this.masterItem && this.masterItem.value_max) || 1000
        },
        value_min() {
            return (this.masterItem && this.masterItem.value_min) || 0
        },
        default_value() {
            return (this.masterItem && this.masterItem.default_value) || null
        },
        is_selection_value_type() {
            return !!(
                this.masterItem && this.masterItem.is_selection_value_type
            )
        },
        // watch: {
        //     'itemModel.task_notes': function(val) {
        //         this.complete_task();
        //     }
        // },
        itemModel: {
            get() {
                return this.value
            },

            set(_value) {
                this.$emit('input', _value)
            },
        },
    },
    methods:{
        complete_task(){
            this.itemModel.task_checked = true;
        }
    }
}
</script>
